import ClientRegisterCharge from './ClientRegisterCharge'
import { JtCrud } from 'jtech-webcomps'
import CollectionPointPage from './CollectionPointPage.vue'
import ContractClient from './ContractClient.vue'
import CollectionPointRegisterPage from './CollectionPointRegisterPage.vue'
import ClientRegisterFormPage from './ClientRegisterFormPage.vue'
import ContractClientRegisterPage from './ContractClientRegisterPage.vue'

const { page, pageTable } = JtCrud

export const registerMenu = [
  {
    // Dados do Cliente
    name: 'CUSTOMER_DATA',
    interface: 'client.registrarNovo',
    icon: 'assignment_ind',
    component: ClientRegisterFormPage,
    title: 'CUSTOMER_INFO',
    crud: false,
    disabled: false,
    isValid: false
  },
  {
    // Dados de Cobrança
    name: 'CHARGE_DATA',
    icon: 'monetization_on',
    interface: 'clientBilling.registrarNovo',
    component: ClientRegisterCharge,
    title: 'CHARGE_INFO',
    crud: false,
    disabled: true,
    isValid: false
  },
  {
    // Pontos de Coleta
    name: 'COLLECTION_POINT',
    icon: 'pin_drop',
    interface: 'collectionPoint.registrarPorCliente',
    component: CollectionPointRegisterPage,
    title: 'COLLECTION_POINT_CLIENT',
    crud: false,
    disabled: true,
    isValid: false
  },
  {
    // Contratos
    name: 'CONTRACTS',
    icon: 'description',
    interface: 'contract.registrarNovo',
    component: ContractClientRegisterPage,
    title: 'CONTRACTS_INFO',
    crud: false,
    disabled: true,
    isValid: false
  }
]
